import { Link } from "react-router-dom"
import { HashLink } from "react-router-hash-link"
import { Space, List } from "../Layout"
import { Media, Texts, Title, Button } from "../Object"
import { Scroll } from "../Animation"

const Service = (props) => {
  return(
    <>
      <Media src={`title/service`} alt={'SERVICE'} class={`p-img__title p-img__title--service`} />
      <div className="l-row">
        <Texts slug="service/title"></Texts>
        <Space size={['64px 0 80px', '56px 0 64px']}>
          <div className="p-box__wrap--middle-button">
            <Scroll state="left">
              <Texts slug="service/middle"></Texts>
            </Scroll>
            <div className="pc">
              <Button slug="service" link="/service/"></Button>
            </div>
          </div>
        </Space>

        <div className="c-grid__repeat--2">
          <List Item={Item} length={6}></List>
        </div>

        
        <div className="sp">
          <Space size={['0', '48px']}></Space>
            <Button slug="service" link="/service/"></Button>
        </div>
      </div>
    </>
  )
}

export const Item = (props) => {
  return (
    <>
      <Scroll>
        <div className="p-box__items--service">
          <Media
            src={`service/list${props.index}`}
            class="p-img__service"
            alt="media"
          ></Media>
          <HashLink
            className="p-box__items--service__button"
            to={`/service/#list${props.index}`}
          >
            <Media
              src={`service/list-number${props.index}`}
              alt="number"
              class="p-img__list-number"
            ></Media>
            <div className="p-box__items--service__line"></div>
            <Texts slug={`service/list${props.index}`}></Texts>
            <div
              className="c-button__img--arrow p-box__items--service__arrow"
              data-state="white"
            ></div>
          </HashLink>
        </div>
      </Scroll>
    </>
  );
};

export default Service;